import React, { useState, useEffect, useCallback, useRef } from "react";
import BackButton from "../../components/BackButton/BackButton";
import "./Galerias.css";

// Página de muestra (/galerias) con varios estilos de galería para que la
// clienta elija cuál sustituye a la galería actual de la home. Todas usan las
// mismas fotos que la home y comparten el mismo visor a pantalla completa.
const PHOTOS = [
  { src: "img/1.webp", w: 960, h: 1280, alt: "Sushi y nigiri de pescado fresco en Sun Taka, Barcelona" },
  { src: "img/2.webp", w: 720, h: 1280, alt: "Sashimi de pescado de temporada — Sun Taka, izakaya en Barcelona" },
  { src: "img/3.webp", w: 960, h: 1280, alt: "Plato de la carta japonesa de Sun Taka, Eixample (Barcelona)" },
  { src: "img/4.webp", w: 853, h: 1280, alt: "Especialidad de wagyu A5 en Sun Taka, restaurante japonés en Barcelona" },
  { src: "img/5.webp", w: 1280, h: 853, alt: "Cocina japonesa de autor del chef Taka en Sun Taka, Barcelona" },
  { src: "img/5.2.webp", w: 826, h: 1100, alt: "Marisco fresco preparado al estilo japonés en Sun Taka, Barcelona" },
  { src: "img/6.1.webp", w: 960, h: 1280, alt: "Plato de sushi de Sun Taka, restaurante izakaya en Barcelona" },
  { src: "img/7.1.webp", w: 626, h: 1100, alt: "Tataki y brasa japonesa en Sun Taka, Barcelona" },
  { src: "img/8.webp", w: 720, h: 1280, alt: "Detalle de un plato japonés de la carta de Sun Taka, Barcelona" },
  { src: "img/9.webp", w: 563, h: 1000, alt: "Ambiente de la izakaya Sun Taka en el Eixample, Barcelona" },
  { src: "img/10.webp", w: 1131, h: 1280, alt: "Sushi y nigiri de pescado fresco en Sun Taka, Barcelona" },
  { src: "img/10.1.webp", w: 821, h: 1100, alt: "Sashimi de pescado de temporada — Sun Taka, izakaya en Barcelona" },
  { src: "img/10.2.webp", w: 948, h: 1200, alt: "Plato de la carta japonesa de Sun Taka, Eixample (Barcelona)" },
  { src: "img/11.1.webp", w: 619, h: 1100, alt: "Especialidad de wagyu A5 en Sun Taka, restaurante japonés en Barcelona" },
  { src: "img/12.webp", w: 912, h: 1280, alt: "Cocina japonesa de autor del chef Taka en Sun Taka, Barcelona" },
  { src: "img/13.webp", w: 563, h: 1000, alt: "Marisco fresco preparado al estilo japonés en Sun Taka, Barcelona" },
  { src: "img/14.webp", w: 667, h: 1000, alt: "Plato de sushi de Sun Taka, restaurante izakaya en Barcelona" },
  { src: "img/15.webp", w: 960, h: 1280, alt: "Tataki y brasa japonesa en Sun Taka, Barcelona" },
  { src: "img/16.webp", w: 1280, h: 960, alt: "Detalle de un plato japonés de la carta de Sun Taka, Barcelona" },
];

const GROUPS = ["Mosaicos", "Carruseles y otros"];

const OPTIONS = [
  { group: 0, id: "masonry", title: "Mosaico (masonry)", desc: "Columnas tipo Pinterest: cada foto conserva su proporción original, sin recortes." },
  { group: 0, id: "grid", title: "Cuadrícula uniforme", desc: "Todas las fotos del mismo tamaño en cuadrados. Ordenada y limpia; al pasar el ratón se amplían ligeramente." },
  { group: 0, id: "bento", title: "Mosaico editorial", desc: "Composición de revista con fotos grandes y pequeñas combinadas. Más dinámica y con más protagonismo para algunas fotos." },
  { group: 0, id: "justified", title: "Filas justificadas", desc: "Estilo Google Fotos: filas de la misma altura que ocupan todo el ancho, cada foto con su anchura natural." },
  { group: 0, id: "feature", title: "Destacada + cuatro", desc: "Bloques con una foto grande y cuatro pequeñas al lado; la grande alterna de izquierda a derecha." },
  { group: 0, id: "stagger", title: "Columnas escalonadas", desc: "Columnas desplazadas en altura, como un collage de revista. Muy elegante y con aire moderno." },
  { group: 0, id: "tiles", title: "Mosaico con palabras", desc: "Fotos combinadas con casillas de color con los platos en japonés. Da personalidad y refuerza la marca." },
  { group: 0, id: "honeycomb", title: "Panal hexagonal", desc: "Fotos recortadas en hexágonos encajados como un panal. Muy original y llamativo." },
  { group: 0, id: "shapes", title: "Arcos y formas", desc: "Fotos con formas de arco, círculo y píldora, inspiradas en la arquitectura japonesa." },
  { group: 0, id: "polaroid", title: "Collage de polaroids", desc: "Fotos con marco blanco, ligeramente giradas y superpuestas, como pegadas en una pared. Cercano y desenfadado." },
  { group: 0, id: "mono", title: "Mosaico en blanco y negro", desc: "A todo el ancho y sin separaciones; las fotos están en blanco y negro y se colorean al pasar el ratón." },
  { group: 1, id: "slider", title: "Carrusel con miniaturas", desc: "Una foto grande protagonista con flechas y una tira de miniaturas debajo para saltar a cualquiera." },
  { group: 1, id: "strip", title: "Tira deslizable", desc: "Fila horizontal que se desliza con el dedo (o las flechas). Muy natural en móvil." },
  { group: 1, id: "marquee", title: "Carrusel infinito automático", desc: "Las fotos pasan solas en bucle continuo. Se detiene al pasar el ratón por encima." },
  { group: 1, id: "accordion", title: "Acordeón", desc: "Franjas verticales que se expanden al pasar el ratón o tocar. Muestra una selección de 7 fotos." },
];

const letter = (i) => String.fromCharCode(65 + i);

// Flecha en SVG (mismo trazo que BackButton) para que quede centrada exacta
// en el círculo; el carácter "›" se descolocaba según la tipografía.
function Chevron({ dir }) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        d={dir === "left" ? "M15 4 7 12l8 8" : "M9 4l8 8-8 8"}
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Img({ photo, index, onOpen, className = "", style }) {
  return (
    <button type="button" className={`gal-item ${className}`} style={style} onClick={() => onOpen(index)} aria-label={`Ampliar: ${photo.alt}`}>
      <img loading="lazy" decoding="async" src={photo.src} width={photo.w} height={photo.h} alt={photo.alt} />
    </button>
  );
}

function Masonry({ onOpen }) {
  return (
    <div className="gal-masonry">
      {PHOTOS.map((p, i) => <Img key={p.src} photo={p} index={i} onOpen={onOpen} />)}
    </div>
  );
}

function Grid({ onOpen }) {
  return (
    <div className="gal-grid">
      {PHOTOS.map((p, i) => <Img key={p.src} photo={p} index={i} onOpen={onOpen} />)}
    </div>
  );
}

// Patrón de tamaños que se repite en el mosaico editorial.
const BENTO_PATTERN = ["big", "", "", "tall", "", "wide", "", "", "tall", "", "big", "", "wide", "", ""];

function Bento({ onOpen }) {
  return (
    <div className="gal-bento">
      {PHOTOS.map((p, i) => (
        <Img key={p.src} photo={p} index={i} onOpen={onOpen} className={BENTO_PATTERN[i % BENTO_PATTERN.length]} />
      ))}
    </div>
  );
}

function Justified({ onOpen }) {
  // Cada foto crece en proporción a su anchura natural, así las filas quedan
  // a la misma altura y llenan el ancho sin recortar casi nada.
  return (
    <div className="gal-justified">
      {PHOTOS.map((p, i) => (
        <div key={p.src} className="gal-justified-cell" style={{ flexGrow: p.w / p.h, flexBasis: `calc(var(--row-h) * ${p.w / p.h})` }}>
          <Img photo={p} index={i} onOpen={onOpen} />
        </div>
      ))}
    </div>
  );
}

function Feature({ onOpen }) {
  const blocks = [];
  for (let i = 0; i < PHOTOS.length; i += 5) blocks.push(i);
  return (
    <div className="gal-feature">
      {blocks.map((start, b) => (
        <div key={start} className={`gal-feature-block ${b % 2 ? "reverse" : ""}`}>
          {PHOTOS.slice(start, start + 5).map((p, j) => (
            <Img key={p.src} photo={p} index={start + j} onOpen={onOpen} className={j === 0 ? "big" : ""} />
          ))}
        </div>
      ))}
    </div>
  );
}

function Stagger({ onOpen }) {
  const cols = [[], [], [], []];
  PHOTOS.forEach((p, i) => cols[i % 4].push(i));
  return (
    <div className="gal-stagger">
      {cols.map((col, c) => (
        <div key={c} className="gal-stagger-col">
          {col.map((i) => <Img key={PHOTOS[i].src} photo={PHOTOS[i]} index={i} onOpen={onOpen} />)}
        </div>
      ))}
    </div>
  );
}

// Casillas de texto intercaladas entre las fotos (posición → contenido).
const WORD_TILES = {
  1: { jp: "寿司", es: "Sushi" },
  7: { jp: "和牛", es: "Wagyu" },
  8: { jp: "刺身", es: "Sashimi" },
  14: { jp: "居酒屋", es: "Izakaya" },
  21: { jp: "日本酒", es: "Sake" },
};

function Tiles({ onOpen }) {
  const cells = [];
  let photo = 0;
  for (let pos = 0; photo < PHOTOS.length; pos++) {
    const word = WORD_TILES[pos];
    if (word) {
      cells.push(
        <div key={`w${pos}`} className={`gal-word ${pos % 2 ? "alt" : ""}`}>
          <span className="jp">{word.jp}</span>
          <span className="es">{word.es}</span>
        </div>
      );
    } else {
      const i = photo++;
      cells.push(<Img key={PHOTOS[i].src} photo={PHOTOS[i]} index={i} onOpen={onOpen} />);
    }
  }
  return <div className="gal-tiles">{cells}</div>;
}

// Posición de cada hexágono: filas alternas de 4 y 3 (escritorio, 8 columnas)
// o de 3 y 2 (móvil, 6 columnas); las filas cortas van desplazadas medio hueco.
function hexPlace(i, wide, narrow) {
  const pair = wide + narrow;
  const block = Math.floor(i / pair);
  const k = i % pair;
  const long = k < wide;
  const row = block * 2 + (long ? 0 : 1) + 1;
  const col = long ? k * 2 + 1 : (k - wide) * 2 + 2;
  return { row, col };
}

function Honeycomb({ onOpen }) {
  const photos = PHOTOS.slice(0, 18);
  return (
    <div className="gal-honeycomb">
      {photos.map((p, i) => {
        const d = hexPlace(i, 4, 3);
        const m = hexPlace(i, 3, 2);
        return (
          <div key={p.src} className="gal-hex" style={{ "--r": d.row, "--c": d.col, "--rm": m.row, "--cm": m.col }}>
            <Img photo={p} index={i} onOpen={onOpen} />
          </div>
        );
      })}
    </div>
  );
}

const SHAPES = ["arch", "circle", "pill", "arch", "round", "circle", "arch", "pill"];

function Shapes({ onOpen }) {
  return (
    <div className="gal-shapes">
      {PHOTOS.map((p, i) => (
        <Img key={p.src} photo={p} index={i} onOpen={onOpen} className={`shape-${SHAPES[i % SHAPES.length]}`} />
      ))}
    </div>
  );
}

const TILTS = [-4, 3, -2, 5, -3, 2, -5, 4];

function Polaroid({ onOpen }) {
  return (
    <div className="gal-polaroid">
      {PHOTOS.map((p, i) => (
        <Img key={p.src} photo={p} index={i} onOpen={onOpen} className="polaroid" style={{ "--tilt": `${TILTS[i % TILTS.length]}deg` }} />
      ))}
    </div>
  );
}

function Mono({ onOpen }) {
  return (
    <div className="gal-mono">
      {PHOTOS.map((p, i) => <Img key={p.src} photo={p} index={i} onOpen={onOpen} />)}
    </div>
  );
}

function Slider({ onOpen }) {
  const [current, setCurrent] = useState(0);
  const thumbsRef = useRef(null);
  const go = (d) => setCurrent((c) => (c + d + PHOTOS.length) % PHOTOS.length);

  useEffect(() => {
    const thumb = thumbsRef.current && thumbsRef.current.children[current];
    if (thumb) thumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }, [current]);

  const p = PHOTOS[current];
  return (
    <div className="gal-slider">
      <div className="gal-slider-main">
        <button type="button" className="gal-slider-img" onClick={() => onOpen(current)} aria-label={`Ampliar: ${p.alt}`}>
          <img key={p.src} src={p.src} width={p.w} height={p.h} alt={p.alt} />
        </button>
        <button type="button" className="gal-arrow gal-prev" onClick={() => go(-1)} aria-label="Anterior"><Chevron dir="left" /></button>
        <button type="button" className="gal-arrow gal-next" onClick={() => go(1)} aria-label="Siguiente"><Chevron dir="right" /></button>
        <span className="gal-counter">{current + 1} / {PHOTOS.length}</span>
      </div>
      <div className="gal-thumbs" ref={thumbsRef}>
        {PHOTOS.map((t, i) => (
          <button type="button" key={t.src} className={i === current ? "active" : ""} onClick={() => setCurrent(i)} aria-label={`Foto ${i + 1}`}>
            <img loading="lazy" decoding="async" src={t.src} alt="" />
          </button>
        ))}
      </div>
    </div>
  );
}

function Strip({ onOpen }) {
  const ref = useRef(null);
  const scroll = (d) => ref.current && ref.current.scrollBy({ left: d * ref.current.clientWidth * 0.8, behavior: "smooth" });
  return (
    <div className="gal-strip-wrap">
      <div className="gal-strip" ref={ref}>
        {PHOTOS.map((p, i) => <Img key={p.src} photo={p} index={i} onOpen={onOpen} />)}
      </div>
      <button type="button" className="gal-arrow gal-prev" onClick={() => scroll(-1)} aria-label="Anterior"><Chevron dir="left" /></button>
      <button type="button" className="gal-arrow gal-next" onClick={() => scroll(1)} aria-label="Siguiente"><Chevron dir="right" /></button>
    </div>
  );
}

function Marquee({ onOpen }) {
  // La lista se duplica para que el bucle sea continuo sin saltos.
  return (
    <div className="gal-marquee">
      <div className="gal-marquee-track">
        {[...PHOTOS, ...PHOTOS].map((p, i) => (
          <Img key={i} photo={p} index={i % PHOTOS.length} onOpen={onOpen} />
        ))}
      </div>
    </div>
  );
}

const ACCORDION_PICKS = [0, 3, 6, 9, 12, 14, 17];

function Accordion({ onOpen }) {
  const [active, setActive] = useState(0);
  return (
    <div className="gal-accordion">
      {ACCORDION_PICKS.map((idx, i) => {
        const p = PHOTOS[idx];
        return (
          <button
            type="button"
            key={p.src}
            className={`gal-accordion-panel ${i === active ? "active" : ""}`}
            onMouseEnter={() => setActive(i)}
            onFocus={() => setActive(i)}
            onClick={() => (i === active ? onOpen(idx) : setActive(i))}
            aria-label={p.alt}
          >
            <img loading="lazy" decoding="async" src={p.src} alt="" />
          </button>
        );
      })}
    </div>
  );
}

function Lightbox({ index, onClose, onMove }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") onMove(-1);
      else if (e.key === "ArrowRight") onMove(1);
    };
    window.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose, onMove]);

  // Deslizar con el dedo para cambiar de foto en móvil.
  const touchX = useRef(null);
  const onTouchStart = (e) => { touchX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchX.current;
    if (Math.abs(dx) > 50) onMove(dx < 0 ? 1 : -1);
    touchX.current = null;
  };

  const p = PHOTOS[index];
  return (
    <div className="gal-lightbox" role="dialog" aria-modal="true" onClick={onClose} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      <img key={p.src} src={p.src} alt={p.alt} onClick={(e) => e.stopPropagation()} />
      <button type="button" className="gal-lightbox-close" onClick={onClose} aria-label="Cerrar">×</button>
      <button type="button" className="gal-arrow gal-prev" onClick={(e) => { e.stopPropagation(); onMove(-1); }} aria-label="Anterior"><Chevron dir="left" /></button>
      <button type="button" className="gal-arrow gal-next" onClick={(e) => { e.stopPropagation(); onMove(1); }} aria-label="Siguiente"><Chevron dir="right" /></button>
      <span className="gal-counter">{index + 1} / {PHOTOS.length}</span>
    </div>
  );
}

const COMPONENTS = {
  masonry: Masonry, grid: Grid, bento: Bento, justified: Justified, feature: Feature, stagger: Stagger,
  tiles: Tiles, honeycomb: Honeycomb, shapes: Shapes, polaroid: Polaroid, mono: Mono,
  slider: Slider, strip: Strip, marquee: Marquee, accordion: Accordion,
};

export default function GaleriasPage() {
  const [open, setOpen] = useState(null);
  const close = useCallback(() => setOpen(null), []);
  const move = useCallback((d) => setOpen((i) => (i + d + PHOTOS.length) % PHOTOS.length), []);

  return (
    <div className="galerias-page">
      <BackButton />
      <header className="galerias-header">
        <h1>Propuestas de galería</h1>
        <p>Estas son varias opciones para la galería de fotos de la web. En todas, al tocar una foto se abre a pantalla completa.</p>
        {GROUPS.map((g, gi) => (
          <nav key={g} className="galerias-nav" aria-label={g}>
            <span className="galerias-nav-label">{g}</span>
            {OPTIONS.map((o, i) => o.group === gi && (
              <a key={o.id} href={`#${o.id}`}>{letter(i)}. {o.title}</a>
            ))}
          </nav>
        ))}
      </header>

      {OPTIONS.map((o, i) => {
        const Gallery = COMPONENTS[o.id];
        const firstOfGroup = i === 0 || OPTIONS[i - 1].group !== o.group;
        return (
          <section key={o.id} id={o.id} className="galerias-section">
            {firstOfGroup && <h2 className="galerias-group">{GROUPS[o.group]}</h2>}
            <div className="galerias-section-head">
              <span className="galerias-letter">Opción {letter(i)}</span>
              <h2>{o.title}</h2>
              <p>{o.desc}</p>
            </div>
            <Gallery onOpen={setOpen} />
          </section>
        );
      })}

      {open !== null && <Lightbox index={open} onClose={close} onMove={move} />}
    </div>
  );
}
